import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const opts = { components, directives, icons: { defaultSet: 'mdi', aliases, sets: { mdi } } }

export const vuetify = createVuetify(opts)
